import { createSelector } from 'reselect';
import { getEntities } from './utils';

const getVendor = createSelector(getEntities, entities => entities.vendor);

export {
  getVendor
};
